import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment-timezone';

@Component({
    selector: 'article-list-item',
    templateUrl: './article-list-item.module.html',
    styleUrls: [
        './article-list-item.module.scss'
    ]
})
export class ArticleListItemModule implements OnInit, AfterViewInit {
    @Input() article: any;
    moment = moment;

    ngAfterViewInit(): void {
    }

    ngOnInit(): void {
    }
}
